import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
  useReducer,
} from "react";
import { connect, useSelector } from "react-redux";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
  SwipeTabs,
  SwipeTab,
} from "../../styles/Global";
import * as Global from "../../styles/Global";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import {
  useTestFilterAGGrid,
  playerTournamentHistory,
} from "../../services/playerApi";
import { FaUserCircle, FaQrcode } from "react-icons/fa";
import {
  Switch,
  Route,
  Link,
  useRouteMatch,
  useParams,
  NavLink,
  useNavigate,
} from "react-router-dom";
import "../../App.scss";
import { findTournament } from "../charts/columnDefs/columnDefs";
import moment from "moment";
import MainProfile from "./MainProfile";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { setPlayer } from "../../features/player/playerSlice";
import SlideUp from "../../components/modals/SlideUp";
import { setModal } from "../../features/modals/modalSlice";
import GridFindTournament from "../../components/GridFindTournament";
import GridFindTournamentCustomEvents from "../../components/GridFindTournamentCustomEvents";
import {
  findTournamentFilterReducer,
  GeocodeLatLng,
} from "../../functions/helperFunctions";
import { setKey, fromAddress, geocode } from "react-geocode";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import FindTournamentModalGroup from "./modals/findTournament/FindTournamentModalGroup";
import { toast } from "react-toastify";
import { BiLogInCircle } from "react-icons/bi";
import SkeletonLoader from "../../components/SkeletonLoader";
import { setOrganizerTournamentsList } from "../../features/refreshScreen/refreshScreenSlice";
setKey(process.env.REACT_APP_GEOCODE_API_KEY);

const mapDispatch = { setPlayer, setModal, setOrganizerTournamentsList };

const FindATournament = ({
  setPlayer,
  setModal,
  setOrganizerTournamentsList,
  isClubProfile,
  profileData,
  isInModal,
  clubParams,
  seasonId,
}) => {
  const sessionVerifyData = JSON.parse(sessionStorage.getItem("verifyData"));
  const sessionPlayer = JSON.parse(sessionStorage.getItem("player"));
  const navigate = useNavigate();
  const initialParams = new URLSearchParams(window.location.search);
  const [params, setParams] = useState(
    isClubProfile ? clubParams : initialParams
  );
  const localFilter =
    JSON.parse(localStorage.getItem("findTournamentFilters")) || {};
  const localOrganizer = JSON.parse(localStorage.getItem("organizer")) || {};
  const localStoragePlayer = JSON.parse(localStorage.getItem("player"));
  console.log("localFilter: ", localFilter);
  console.log("localOrganizer: ", localOrganizer);
  console.log("localStoragePlayer: ", localStoragePlayer);
  console.log("initialParams: ", initialParams.get("platform"));
  console.log("params: ", params.get("platform"));
  console.log("params.lat: ", params.get("lat"));
  console.log("params.lng: ", params.get("lng"));
  const player = useSelector((state) => state.player);
  const organizer = useSelector((state) => state.organizer);
  const organizerAccount = useSelector((state) => state.accountID);
  const organizerTournamentsList = useSelector(
    (state) => state.refresh.organizerTournamentsList
  );
  const pathEnv = new URL(window.location.href).host.split(".")[0];
  const platform = params.get("platform")
    ? params.get("platform")
    : localFilter && localFilter.hasOwnProperty("platform")
    ? localFilter.platform
    : null;
  const userID =
    params && params.get("user")
      ? params.get("user")
      : player && player.userID
      ? player.userID
      : localStoragePlayer && localStoragePlayer.hasOwnProperty("userID")
      ? localStoragePlayer.userID
      : null;
  const accountID =
    localFilter && localFilter.hasOwnProperty("accountid")
      ? localFilter.accountid
      : localOrganizer.accountid
      ? localOrganizer.accountid
      : null;
  const paidPlayer =
    player.paidPlayer ||
    player.isAdmin === "true" ||
    player.isAdmin === true ||
    params.get("paidPlayer") === "Yes" ||
    params.get("paidPlayer") === "yes";
  const paidOrganizer =
    player.paidOrganizer ||
    player.isAdmin === "true" ||
    player.isAdmin === true ||
    params.get("paidOrganizer") === "Yes" ||
    params.get("paidOrganizer") === "yes" ||
    organizer?.organizerData?.subLevelNum > 0 ||
    localOrganizer?.organizerData?.subLevelNum > 0;
  const isPaid = paidPlayer || paidOrganizer;
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const userAgent = window.navigator.userAgent;
  console.log("userAgent: ", userAgent);
  console.log(
    "FindATournament params.get('customid'): ",
    params.get("customId")
  );
  console.log(
    "FindATournament params.get('customtype'): ",
    params.get("customType")
  );
  // console.log("FindATournament organizer: ", organizer);
  // console.log("FindATournament organizerAccount: ", organizerAccount);
  // console.log("FindATournament accountID: ", accountID);
  const [modalData, setModalData] = useState(null);
  const [geocodeError, setGeocodeError] = useState(false);
  const [loadingWeb, setLoadingWeb] = useState(
    !platform && !isClubProfile ? true : false
  );
  const sport = new URL(window.location.href).pathname.split("/")[2];
  const [value, setValue] = useState(() => {
    if (isClubProfile || seasonId) {
      return 0;
    }
    return 0;
  });
  const [tableType, setTableType] = useState(0);
  const [search, setSearch] = useState("");
  const [promos, setPromos] = useState([]);
  function SetLocationIfWeb() {
    return new Promise((resolve, reject) => {
      if ("geolocation" in navigator) {
        console.log("geolocation in navigator");
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            resolve({ latitude, longitude });
          },
          (error) => {
            console.error("Error getting location:", error);
            reject(error);
          }
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  }
  async function GetLocation() {
    if (!isClubProfile) {
      console.log("GetLocation running");

      // Check if location is explicitly disabled
      if (params.get("location") === "disabled") {
        console.log("Location is disabled via params, returning 0/0");
        return { latitude: 0, longitude: 0 };
      }

      try {
        const location = await SetLocationIfWeb();
        return location;
      } catch (error) {
        console.error("getLocation error: ", error);
        return { latitude: 0, longitude: 0 }; // Return proper object with 0/0 coordinates
      }
    }
    return { latitude: 0, longitude: 0 }; // Default for club profiles
  }
  const [state, dispatch] = useReducer(findTournamentFilterReducer, {
    lat:
      !platform || params.get("location") === "disabled"
        ? localFilter.lat
          ? localFilter.lat
          : 0
        : params.get("lat")
        ? params.get("lat")
        : 0,
    lng:
      !platform || params.get("location") === "disabled"
        ? localFilter.lng
          ? localFilter.lng
          : 0
        : params.get("lng")
        ? params.get("lng")
        : 0,
    distance: seasonId
      ? 10000
      : localFilter.distance
      ? localFilter.distance
      : params.get("location") === "disabled"
      ? 10000
      : 100,
    generation: localFilter.generation || "All",
    //Set start date to today since we'll be on the upcoming tab
    dateStart: new Date().toISOString(),
    //Set End date to 2 years out since we'll be on the upcoming tab
    dateEnd: new Date(
      new Date().setMonth(new Date().getMonth() + isClubProfile ? 12 : 6)
    ).toISOString(),
    sort: localFilter.sort || false,
    mineUpcoming: localFilter.mineUpcoming ? localFilter.mineUpcoming : false,
    minePlayer: localFilter.hasOwnProperty("minePlayer")
      ? localFilter.minePlayer
      : userID && params.get("pin") && params.get("pin") !== ""
      ? true
      : false,
    mineOrganizer: localFilter.hasOwnProperty("mineOrganizer")
      ? localFilter.mineOrganizer
      : false,
    showCustomDistance: localFilter.showCustomDistance
      ? localFilter.showCustomDistance
      : false,
    customDistance: localFilter.customDistance
      ? localFilter.customDistance
      : null,
    customAddress: localFilter.customAddress ? localFilter.customAddress : null,
    customLat: localFilter.showCustomDistance ? localFilter.customLat : null,
    customLng: localFilter.showCustomDistance ? localFilter.customLng : null,
    favorites: localFilter.hasOwnProperty("favorites")
      ? localFilter.favorites
      : false,
    timezone: tz,
    platform: params.get("platform"),
    resetURLParams: false,
    promoImage: localFilter.promoImage ? localFilter.promoImage : "",
  });

  useEffect(() => {
    // Fetch location and update state on mount if no platform is set AND no lat/lng is set in local filter
    if (!isClubProfile) {
      async function fetchLocationAndUpdateState() {
        if (!platform) {
          console.log("fetchLocationAndUpdateState running");
          // setLoadingWeb(true);
          try {
            const location = await GetLocation();
            console.log("fetchLocationAndUpdateState location: ", location);

            // If location services failed or returned 0, set coordinates to 0/0
            if (!location || location === 0) {
              console.log(
                "Location services failed or disabled, setting coordinates to 0/0"
              );
              dispatch({
                type: "lat",
                lat: 0,
              });
              dispatch({
                type: "lng",
                lng: 0,
              });
            } else {
              // Normal location update
              if (state.lat !== location.latitude) {
                dispatch({
                  type: "lat",
                  lat: location.latitude,
                });
              }
              if (state.lng !== location.longitude) {
                dispatch({
                  type: "lng",
                  lng: location.longitude,
                });
              }
            }
            setTimeout(() => {
              setLoadingWeb(false);
            }, 1000);
          } catch (error) {
            console.error("Error fetching location", error);
            // Explicitly set coordinates to 0/0 when location services fail
            console.log("Setting coordinates to 0/0 due to location error");
            dispatch({
              type: "lat",
              lat: 0,
            });
            dispatch({
              type: "lng",
              lng: 0,
            });
            setTimeout(() => {
              setLoadingWeb(false);
            }, 1000);
          }
        } else {
          if (loadingWeb) {
            setTimeout(() => {
              setLoadingWeb(false);
            }, 1000);
          }
        }
      }
      fetchLocationAndUpdateState();
    }
  }, []);

  console.log("Find tournament promoId: ", params.get("promoId"));

  // Deep equality check function for dataCallBody objects
  const isDataCallBodyEqual = useCallback((obj1, obj2) => {
    if (!obj1 || !obj2) return obj1 === obj2;

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }

    return true;
  }, []);

  // Coordinate validation function
  const hasValidCoordinates = useCallback(() => {
    // Always return true - we initialize with whatever coords we have (even 0/0)
    // Web (no platform): Geolocation useEffect will update coords after initialization
    // App (platform set): Coords come from URL params or app's location services
    // Location disabled: Works with 0/0 coords and large distance
    return true;
  }, []);

  // Initialize dataCallBody - when platform is set (ios/android), coordinates come from URL params or app
  const [dataCallBody, setDataCallBody] = useState(() => {
    // Always initialize dataCallBody with whatever coordinates we have
    // Web (no platform): Will update via geolocation useEffect
    // App (platform=ios/android): Gets coordinates from URL params or app's location services
    const initialData = {
      sport: sport,
      lat: params.get("lat") || state.lat || 0,
      lng: params.get("lng") || state.lng || 0,
      filterdistance: "100mi",
      type: isClubProfile
        ? "Organizer"
        : params.get("promoid")
        ? "Promo"
        : params.get("customType")
        ? params.get("customType")
        : "Upcoming",
      sortDir: value === 0 ? "asc" : "desc",
      customID:
        isClubProfile && profileData
          ? profileData.accountId
          : params.get("customId")
          ? params.get("customId")
          : null,
      seasonId: seasonId,
      sort: state.sort,
      search: search,
      dateEnd: state.dateEnd,
      dateStart: state.dateStart,
      userID: userID,
      playerID: state.minePlayer ? state.minePlayer : userID,
      accountID: state.mineOrganizer ? state.mineOrganizer : accountID,
      favorites: state.favorites,
      timezone: tz,
      userAgent: userAgent,
      promoItemId: params.get("promoid"),
      paidPlayer: paidPlayer,
      paidOrganizer: paidOrganizer,
      environment:
        pathEnv === "app" ? "production" : pathEnv === "beta" ? "beta" : "",
    };
    console.log("🔵 Initial dataCallBody:", initialData);
    return initialData;
  });

  // Centralized function to create the complete dataCallBody with all current values
  const createCurrentDataCallBody = useCallback(() => {
    // For club profiles, always create the dataCallBody regardless of coordinates
    if (!isClubProfile && !hasValidCoordinates()) {
      console.log(
        "❌ createCurrentDataCallBody: No valid coordinates, returning null",
        {
          isClubProfile,
          hasValidCoords: hasValidCoordinates(),
          lat: state.lat,
          lng: state.lng,
          platform,
        }
      );
      return null;
    }

    console.log("✅ createCurrentDataCallBody: Creating dataCallBody", {
      lat: state.showCustomDistance ? state.customLat : state.lat,
      lng: state.showCustomDistance ? state.customLng : state.lng,
      platform,
    });

    return {
      sport: sport,
      lat: state.showCustomDistance ? state.customLat : state.lat,
      lng: state.showCustomDistance ? state.customLng : state.lng,
      filterdistance: "100mi",
      type: isClubProfile
        ? "Organizer"
        : params.get("promoid")
        ? "Promo"
        : !state.resetURLParams && params.get("customType")
        ? params.get("customType")
        : params.get("gameid")
        ? "Single"
        : params.get("accountid")
        ? "Organizer"
        : value === 0
        ? "Upcoming"
        : value === 1
        ? "Past"
        : "Mine",
      sortDir:
        value === 2
          ? state.mineUpcoming
            ? "desc"
            : "asc"
          : value === 0
          ? "asc"
          : "desc",
      distance:
        (params.get("location") === "disabled" && !state.customDistance) ||
        value === 2
          ? 10000
          : state.distance
          ? state.distance
          : 100,
      generation: value === 2 ? "All" : state.generation,
      sort: value === 2 ? "date" : state.sort ? "distance" : "date",
      customID:
        isClubProfile && profileData
          ? profileData.accountId
          : params.get("customId")
          ? params.get("customId")
          : null,
      seasonId: seasonId,
      search: search,
      dateEnd:
        typeof state.dateEnd === "string"
          ? state.dateEnd
          : state.dateEnd.toISOString(),
      dateStart:
        typeof state.dateStart === "string"
          ? state.dateStart
          : state.dateStart.toISOString(),
      userID: userID,
      playerID: value === 2 && state.minePlayer ? userID : null,
      accountID: value === 2 && state.mineOrganizer ? accountID : null,
      favorites: value === 2 && state.favorites ? userID : null,
      timezone: tz,
      userAgent: userAgent,
      promoItemId: params.get("promoid"),
      paidPlayer: paidPlayer,
      paidOrganizer: paidOrganizer,
      environment:
        pathEnv === "app" ? "production" : pathEnv === "beta" ? "beta" : "",
    };
  }, [
    isClubProfile,
    hasValidCoordinates,
    sport,
    state.showCustomDistance,
    state.customLat,
    state.customLng,
    state.lat,
    state.lng,
    state.resetURLParams,
    state.mineUpcoming,
    state.distance,
    state.customDistance,
    state.generation,
    state.sort,
    state.dateEnd,
    state.dateStart,
    state.minePlayer,
    state.mineOrganizer,
    state.favorites,
    profileData,
    params,
    value,
    seasonId,
    search,
    userID,
    tz,
    userAgent,
    pathEnv,
    paidPlayer,
    paidOrganizer,
  ]);

  // Improved update function with deep comparison
  const updateDataCallBodyIfChanged = useCallback(
    (reason = "unknown") => {
      const newDataCallBody = createCurrentDataCallBody();

      if (!newDataCallBody) {
        console.log(
          `updateDataCallBodyIfChanged: Could not create new dataCallBody, skipping (${reason})`
        );
        return;
      }

      if (!isDataCallBodyEqual(dataCallBody, newDataCallBody)) {
        setDataCallBody(newDataCallBody);
      }
    },
    [dataCallBody, createCurrentDataCallBody, isDataCallBodyEqual]
  );

  // Initialize dataCallBody once we have valid coordinates (for non-club profiles)
  useEffect(() => {
    if (!isClubProfile && !dataCallBody && hasValidCoordinates()) {
      const initialDataCallBody = createCurrentDataCallBody();
      if (initialDataCallBody) {
        setDataCallBody(initialDataCallBody);
      }
    }
  }, [isClubProfile, hasValidCoordinates]);

  // Initialize dataCallBody immediately for club profiles and season profiles
  useEffect(() => {
    if ((isClubProfile || seasonId) && !dataCallBody) {
      // Create dataCallBody directly to avoid dependency on createCurrentDataCallBody
      const initialDataCallBody = {
        sport: sport,
        lat: state.lat || 0,
        lng: state.lng || 0,
        filterdistance: "100mi",
        type: isClubProfile ? "Organizer" : "Upcoming",
        sortDir: "asc",
        distance: seasonId ? 10000 : 100,
        generation: "All",
        sort: "date",
        customID: isClubProfile && profileData ? profileData.accountId : null,
        seasonId: seasonId,
        search: search,
        dateEnd: state.dateEnd,
        dateStart: state.dateStart,
        userID: userID,
        playerID: null,
        accountID: null,
        favorites: null,
        timezone: tz,
        userAgent: userAgent,
        promoItemId: params.get("promoid"),
        paidPlayer: paidPlayer,
        paidOrganizer: paidOrganizer,
        environment:
          pathEnv === "app" ? "production" : pathEnv === "beta" ? "beta" : "",
      };

      setDataCallBody(initialDataCallBody);
    }
  }, [isClubProfile, seasonId]);

  useEffect(() => {
    if (organizerTournamentsList && dataCallBody) {
      // Create a new dataCallBody with the organizer data
      const newDataCallBody = {
        ...dataCallBody,
        ...organizerTournamentsList,
      };

      // Use the deep comparison function
      if (!isDataCallBodyEqual(dataCallBody, newDataCallBody)) {
        setDataCallBody(newDataCallBody);
      }

      setTimeout(() => {
        setOrganizerTournamentsList(null);
      }, 1000);
    }
  }, [
    organizerTournamentsList,
    dataCallBody,
    isDataCallBodyEqual,
    setOrganizerTournamentsList,
  ]);

  console.log("find a tournament promoid: ", params.get("promoid"));

  console.log("FAT seasonId: ", seasonId);

  useEffect(() => {
    if (
      (!player || !player.userID) &&
      localStoragePlayer &&
      localStoragePlayer.userID
    ) {
      setPlayer(localStoragePlayer);
    }
  }, [player]);

  // console.log("FindTournament localFilter: ", localFilter);
  // console.log(
  //   "FindTournament localFilter lat: ",
  //   localFilter.showCustomDistance
  //     ? localFilter.customLat
  //     : localFilter.lat
  //     ? localFilter.lat
  //     : params.get("lat")
  // );
  console.log("FindTournament state: ", state);
  // console.log("FindTournament swipe value: ", value);

  async function SetNewDataCallBody() {
    updateDataCallBodyIfChanged("SetNewDataCallBody function");
  }

  function debounce(func, wait) {
    let timeout;
    function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    }
    executedFunction.cancel = () => clearTimeout(timeout);
    return executedFunction;
  }

  // Simple debounced function that just triggers a flag
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const debouncedUpdateDataCallBody = useDebouncedCallback(() => {
    console.log("� FindATournament - Debounced update triggered");
    setShouldUpdate(true);
  }, 1000);

  useEffect(() => {
    // Always save to localStorage
    localStorage.setItem("findTournamentFilters", JSON.stringify({ ...state }));

    // Re-enable updates but with a simpler approach to avoid dependency loops
    if (dataCallBody) {
      const newDataCallBody = createCurrentDataCallBody();

      if (newDataCallBody) {
        // Simple comparison to avoid frequent updates
        const currentStr = JSON.stringify(dataCallBody);
        const newStr = JSON.stringify(newDataCallBody);

        if (currentStr !== newStr) {
          setDataCallBody(newDataCallBody);
        }
      }
    } else {
    }
  }, [state]);

  // Update dataCallBody when tab value changes (Upcoming/Past/Mine)
  useEffect(() => {
    if (dataCallBody) {
      const newDataCallBody = createCurrentDataCallBody();

      if (newDataCallBody) {
        const currentStr = JSON.stringify(dataCallBody);
        const newStr = JSON.stringify(newDataCallBody);

        if (currentStr !== newStr) {
          console.log("Tab changed, updating dataCallBody for value:", value);
          setDataCallBody(newDataCallBody);
        }
      }
    }
  }, [value]);

  const fullWidthCellRenderer = useMemo(() => {
    return GridFindTournamentCustomEvents;
  }, []);

  const isFullWidthRow = useCallback(function (rowNode) {
    return true;
  }, []);

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
    console.log("handleChange newValue: ", newValue);
    if (!platform && newValue === 2) {
      toast.error(
        "Download the Scoreholio app to view your tournaments and access all features!",
        { autoClose: 7000 }
      );
    } else {
      setValue(newValue);
    }
  };

  // Debounced search update
  const debouncedSearchUpdate = useDebouncedCallback(() => {
    updateDataCallBodyIfChanged("debounced search change");
  }, 500);

  useEffect(() => {
    if (search && search !== "") {
      debouncedSearchUpdate();
    }
  }, [search, debouncedSearchUpdate]);

  useEffect(() => {
    if (value === 0) {
      dispatch({
        type: "date_start",
        dateStart: new Date().toISOString(),
      });
      dispatch({
        type: "date_end",
        dateEnd: new Date(new Date().setMonth(new Date().getMonth() + 6)),
      });
    } else if (value === 1) {
      dispatch({
        type: "date_end",
        dateEnd: new Date().toISOString(),
      });
      dispatch({
        type: "date_start",
        dateStart: new Date(
          new Date(new Date().toISOString()).setFullYear(
            new Date().getFullYear() - 5
          )
        ),
      });
    } else if (value === 2) {
      dispatch({
        type: "mineUpcoming",
        mineUpcoming: false,
      });
      dispatch({
        type: "date_start",
        dateStart: new Date().toISOString(),
      });
      dispatch({
        type: "date_end",
        dateEnd: new Date(new Date().setFullYear(new Date().getFullYear() + 5)),
      });
    }
  }, [value]);

  function handleSessionStorageChange(event) {
    console.log("handleSessionStorageChange event: ", event);
    // Check if the change is in sessionStorage
    if (event.storageArea === sessionStorage) {
      console.log("Session storage changed");
      // You can access event.key, event.oldValue, and event.newValue
      // to see what changed in sessionStorage
    }
  }

  window.addEventListener("storage", handleSessionStorageChange);

  return loadingWeb ? (
    <ContentSection style={{ height: "auto", flex: 0 }}>
      <SkeletonLoader h1={100} h2={100} h3={100} />
    </ContentSection>
  ) : (
    <>
      {isClubProfile || isInModal ? null : <FindTournamentModalGroup />}
      {!isClubProfile && !platform && sessionVerifyData && (
        <>
          {sessionPlayer && (
            <FlexRow
              align="center"
              justify="center"
              style={{
                width: "100%",
                maxWidth: 600,
                // border: "1px solid white",
                flex: 0,
                padding: "0 10px 10px",
              }}
            >
              {sessionPlayer.avatarLink && (
                <img
                  src={sessionPlayer.avatarLink}
                  alt="profile"
                  style={{
                    // width: "100%",
                    height: 75,
                    objectFit: "contain",
                    objectPosition: "top",
                    borderRadius: 50,
                    boxShadow: "0px 4px 4px #9a9a9a70",
                  }}
                />
              )}
              <FlexColumn style={{ marginLeft: 10, flex: 0 }}>
                <Text>{sessionPlayer.userDisplayName}</Text>
                <Text size=".8em" style={{ marginTop: 5 }}>
                  {sessionPlayer.userEmail}
                </Text>
                <LargeButtonSecondary
                  onClick={() => {
                    toast.success("You have been logged out.");
                    sessionStorage.clear();
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  }}
                  style={{
                    padding: "5px 7px",
                    borderRadius: 5,
                    marginTop: 7,
                  }}
                >
                  <ButtonText
                    secondary
                    style={{ fontWeight: "800", fontSize: 10 }}
                  >
                    Logout
                  </ButtonText>
                  <BiLogInCircle
                    size={18}
                    color={Global.red}
                    style={{ marginLeft: 5 }}
                  />
                </LargeButtonSecondary>
              </FlexColumn>
            </FlexRow>
          )}
        </>
      )}
      <ContentSection
        className="fullWidthCustom"
        style={{
          flex: 0,
          margin: isClubProfile || isInModal ? null : "0 15px 15px 15px",
          padding: "10px 0 0 ",
          borderTopLeftRadius: isClubProfile && 0,
          borderTopRightRadius: isClubProfile && 0,
        }}
      >
        {!params.get("promoid") && (
          <SwipeTabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant="fullWidth"
            aria-label="advanced stats tabs"
            marginTop={"0px"}
            width={
              // allAccessUsers.includes(account) ?
              isClubProfile || seasonId ? "50%" : "33.333%"
              // "50%"
              // : "50%"
            }
          >
            <SwipeTab label="Upcoming" {...a11yProps(0)} />
            <SwipeTab label="Past" {...a11yProps(1)} />
            {!isClubProfile && !seasonId && (
              <SwipeTab label="Mine" {...a11yProps(2)} />
            )}
          </SwipeTabs>
        )}
        <GridFindTournament
          id="grid-global-FindATournament"
          apiURL="find/get-tournaments"
          columnDefs={findTournament}
          //   defaultColDef={defaultColDef}
          dataCallBody={dataCallBody}
          paginationPageSize="50"
          showSearchBar={true}
          modalData={modalData}
          setModalData={setModalData}
          // ShowModalType={() => setShowProfileModal(true)}
          shouldShowModal={true}
          showFilter={true}
          // modalData={modalData}
          // setModalData={setModalData}
          // ShowModalType={() => setShowProfileModal(true)}
          // shouldShowModal={true}
          noBorder={true}
          noHeader={true}
          isFullWidthRow={isFullWidthRow}
          fullWidthCellRenderer={fullWidthCellRenderer}
          tableValue={value}
          search={search}
          setSearch={setSearch}
          state={state}
          dispatch={dispatch}
          geocodeError
          isPromo={params.get("promoid") ? true : false}
          isClubProfile={isClubProfile}
          isPaid={isPaid}
          platform={platform}
          // seasonId={"RosDmlsbRoRCO7V5d4kC"}
          seasonId={seasonId}
        />
      </ContentSection>
    </>
  );
};

export default connect(null, mapDispatch)(FindATournament);
